<template>
    <div>
        <form-input 
            class="configuration-item"
            :inputValue.sync="axis_name"
            label="Name"
            size="mini"
            placeholder="Axis Name"
        >
            <style-field title="Axis Name" :textStyle="axis_nameTextStyle"></style-field>
        </form-input>

        <form-select 
            class="configuration-item"
            :inputValue.sync="axis_nameLocation"
            label="Axis Name Location"
            placeholder="Location of axis name"
            size="mini"
            :options="axisNameLocation"
        >
        </form-select>

        <axis-tick>
            
        </axis-tick>
    </div>
</template>

<script>
import FormInput from '@/components/Form/FormInput'
import FormLabelTitle from '@/components/Form/FormLabelTitle'
import FormInputFloat from '@/components/Form/FormInputFloat'
import FormSelect from '@/components/Form/FormSelect'
import StyleField from '@/components/Form/StyleField'
import AxisTick from '@/components/SidebarDetail/EchartConfiguration/AxisTick'

    export default {
        components: {
            'form-input': FormInput,
            'form-label-title': FormLabelTitle,
            'form-input-float': FormInputFloat,
            'form-select': FormSelect,
            'style-field': StyleField,
            'axis-tick': AxisTick,
        },
        props: {
            name: {
                type: String | Number
            },
            nameLocation: {
                type: String | Number
            },
            nameTextStyle: {
                type: Object
            },
            nameGap: {
                type: String | Number
            },
            nameRotate: {
                type: String | Number
            },
            axisTick: {
                type: Object
            },
            axisLabel: {
                type: Object
            },
        },
        data() {
            return {
                axisNameLocation: [
                    { id: 'start', name: 'Start' },
                    { id: 'middle', name: 'Middle' },
                    { id: 'end', name: 'End' }
                ],
            }
        },
        computed: {
            axis_name: {
                set(val){
                    this.$emit('update:name', val)
                },
                get(){
                    return this.name
                }
            },
            axis_nameLocation: {
                set(val){
                    this.$emit('update:nameLocation', val)
                },
                get(){
                    return this.nameLocation
                }
            },
            axis_nameTextStyle: {
                set(val){
                    this.$emit('update:nameTextStyle', val)
                },
                get(){
                    return this.nameTextStyle
                }
            },
            axis_nameGap: {
                set(val){
                    this.$emit('update:nameGap', val)
                },
                get(){
                    return this.nameGap
                }
            },
            axis_nameRotate: {
                set(val){
                    this.$emit('update:nameRotate', val)
                },
                get(){
                    return this.nameRotate
                }
            },
            axis_axisTick: {
                set(val){
                    this.$emit('update:axisTick', val)
                },
                get(){
                    return this.axisTick
                }
            },
            axis_axisLabel: {
                set(val){
                    this.$emit('update:axisLabel', val)
                },
                get(){
                    return this.axisLabel
                }
            },
            
        },
    }
</script>

<style scoped>
.position-input-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-gap: 10px;
    margin: 8px 0 16px 0;
}
.position-item-input-container {
    display: flex;
    align-items: center;
}
.position-label {
    font-size: 11px;
    color: var(--description-grey);
}
.position-label-left-col {
    width: 60px;
}
.position-label-right-col {
    width: 90px;
}
.configuration-item {
    margin-bottom: var(--space-16);
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/EchartConfiguration/AxisInput.vue